module.exports = __webpack_public_path__ + "dist/assets/img/growth.4238c949.svg";